import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, NgModule, NO_ERRORS_SCHEMA, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MatCalendar, MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Subject } from 'rxjs';

@Component({
    selector: 'POS-DatepickerHeader.component.ts',
    template: `
    <mat-calendar-header>
        <button mat-icon-button (click)="todayClicked()" title="Today">
            <i class="fa-regular fa-clock" style="font-size: 18px;"></i>
        </button>
        <button mat-icon-button (click)="clearClicked()" title="Clear">
            <i class="fa-regular fa-times-circle" style="font-size: 18px;"></i>
        </button>
      </mat-calendar-header>
  `,
    standalone: false
})
export class DatepickerHeaderComponent<D> implements OnDestroy {
  private _destroyed = new Subject<void>();

  constructor(
      private _datePicker: MatDatepicker<D>,
      private _calendar: MatCalendar<D>,
      private _dateAdapter: DateAdapter<D>,
      cdr: ChangeDetectorRef
  ) {
      _calendar.stateChanges
          .subscribe(() => cdr.markForCheck());
  }

  /**
   * set to today date
   */
  public todayClicked() {
      this._calendar.activeDate = this._dateAdapter.today();
      this._datePicker.select(this._dateAdapter.today());
      this._datePicker.close();
  }

  /**
   * clear selected date from mat datepicker
   */
  public clearClicked() {
      this._datePicker.select(null as any);
      this._datePicker.close();
  }

  ngOnDestroy() {
      this._destroyed.next();
      this._destroyed.complete();
  }
}

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule
    ],
    providers: [
        MatDatepickerModule
    ],
    declarations: [DatepickerHeaderComponent],
    exports: [DatepickerHeaderComponent],
    schemas: [NO_ERRORS_SCHEMA]
})
export class DatepickerHeaderModule { }
